/**
 * Handles individual bundle product form submissions with AJAX cart functionality
 */
class BundleProductForm extends HTMLElement {
  constructor() {
    super();
    
    this.form = this.querySelector('form');
    this.submitBtn = this.querySelector('[name="add"]');
    
    if (this.form && this.submitBtn && theme.settings.afterAddToCart !== 'no-js') {
      this.form.addEventListener('submit', this.handleSubmit.bind(this));
    }
  }

  /**
   * Handles submission of individual bundle product form
   * @param {object} evt - Event object
   */
  async handleSubmit(evt) {
    evt.preventDefault();
    
    if (this.submitBtn.getAttribute('aria-disabled') === 'true' || this.submitBtn.classList.contains('is-loading')) {
      return;
    }

    // Disable button and show loading state
    this.submitBtn.setAttribute('aria-disabled', 'true');
    this.submitBtn.classList.add('is-loading');

    const formData = new FormData(this.form);
    const sectionsToUpdate = ['page-header', 'cart-drawer']
      .map((sel) => document.querySelector(sel))
      .filter((el) => el);
    const sectionIds = sectionsToUpdate.map((el) => el.dataset.sectionId);

    formData.append('sections_url', window.location.pathname);
    formData.append('sections', sectionIds.join(','));

    const fetchRequestOpts = {
      method: 'POST',
      headers: {
        Accept: 'application/javascript',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: formData
    };

    try {
      const response = await fetch(theme.routes.cartAdd, fetchRequestOpts);
      const data = await response.json();
      
      let error = typeof data.description === 'string' ? data.description : data.message;
      if (data.errors && typeof data.errors === 'object') {
        error = Object.entries(data.errors).map((item) => item[1].join(', '));
      }
      
      if (data.status) {
        throw new Error(error || 'Error adding product to cart');
      }
      
      if (!response.ok) {
        throw new Error(response.status);
      }

      // Update cart sections
      if (data.sections && sectionsToUpdate.length === Object.keys(data.sections).length) {
        sectionsToUpdate.forEach((el) => {
          el.updateFromCartChange(data.sections[el.dataset.sectionId]);
        });
      } else {
        // Fallback: dispatch cart change event
        this.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true }));
      }

      // Handle post-add-to-cart behavior
      if (theme.settings.afterAddToCart === 'drawer') {
        const drawer = document.querySelector('.js-cart-drawer');
        if (drawer && typeof drawer.open === 'function') {
          drawer.open(this.submitBtn);
        }
      } else if (theme.settings.afterAddToCart === 'page') {
        setTimeout(() => {
          window.location.href = theme.routes.cart;
        }, 300);
      } else if (theme.settings.afterAddToCart === 'notification') {
        const notification = document.getElementById('AddedNotification').content.firstElementChild.cloneNode(true);
        notification.dataset.productTitle = data.product_title;
        let notificationContainer = document.querySelector('.pageheader--sticky');
        if (!notificationContainer) {
          notificationContainer = document.querySelector('body');
        }
        notificationContainer.appendChild(notification);
      }

      // Dispatch success event
      this.dispatchEvent(new CustomEvent('on:cart:add', {
        bubbles: true,
        detail: {
          variantId: data.variant_id
        }
      }));

      // Show success state
      this.submitBtn.classList.add('is-success');
      this.submitBtn.removeAttribute('aria-disabled');
      setTimeout(() => {
        this.submitBtn.classList.remove('is-loading');
        this.submitBtn.classList.remove('is-success');
      }, 2000);

    } catch (error) {
      console.log('[bundle-product] error', error.message || error); // eslint-disable-line
      
      this.dispatchEvent(new CustomEvent('on:cart:error', {
        bubbles: true,
        detail: {
          error: error.message || String(error)
        }
      }));

      // Cart may change despite error
      this.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true }));

      // Re-enable button
      this.submitBtn.classList.remove('is-loading');
      this.submitBtn.classList.remove('is-success');
      this.submitBtn.removeAttribute('aria-disabled');
    }
  }
}

if (!customElements.get('bundle-product-form')) {
  window.customElements.define('bundle-product-form', BundleProductForm);
}